module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"AI에게 직접 물어보기","error":"지금은 AI 답변 화면을 열 수 없어요. 잠시 후 다시 시도해 주세요.","retry":"다시 시도","close":"닫기"}}')
  delete Component.options._Ctor
}
